import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

// Slices
import authSlice from './slices/authSlice';
import uiSlice from './slices/uiSlice';
import searchSlice from './slices/searchSlice';
import dashboardSlice from './slices/dashboardSlice';
import bookingsSlice from './slices/bookingsSlice';
import vehiclesSlice from './slices/vehiclesSlice';
import driversSlice from './slices/driversSlice';
import usersSlice from './slices/usersSlice';

// API
import { apiSlice } from './api/apiSlice';

export const store = configureStore({
  reducer: {
    // API
    [apiSlice.reducerPath]: apiSlice.reducer,
    
    // Auth
    auth: authSlice,
    
    // UI
    ui: uiSlice,
    search: searchSlice,
    
    // Features
    dashboard: dashboardSlice,
    bookings: bookingsSlice,
    vehicles: vehiclesSlice,
    drivers: driversSlice,
    users: usersSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(apiSlice.middleware),
  devTools: import.meta.env.DEV,
});

// Setup listeners for RTK Query
setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export hooks
export { useAppDispatch, useAppSelector } from './hooks';